import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { locale } from "devextreme/localization";
import { useAuthStore } from "./contexts/useAuthStore";
import { RootLayout } from "./components/layout/RootLayout";

locale("it");

const LoginPage = lazy(() => import("@/pages/auth/login-page"));
const Project = lazy(() => import("@/pages/projects/project-view"));
const GlobalSecret = lazy(() => import("@/pages/global/global-secret-view"));

const Loader = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100vh"
  >
    <CircularProgress />
  </Box>
);

export const App: React.FC = () => {
  const { isAuthenticated, loading } = useAuthStore();

  if (loading) return <Loader />;

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {!isAuthenticated ? (
          <>
            <Route path="/auth/signin" element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/auth/signin" replace />} />
          </>
        ) : (
          <Route element={<RootLayout />}>
            <Route path="/" element={<Navigate to="/projects" replace />} />
            <Route path="/projects" element={<Project />} />
            <Route path="/globals-secrets" element={<GlobalSecret />} />
            <Route path="*" element={<Navigate to="/projects" replace />} />
          </Route>
        )}
      </Routes>
    </Suspense>
  );
};
